import Model from '@/core/classes/Model'
import Servers from './Servers.collection'

export default class Environment extends Model {
  /**
   * Environment model relations
   *
   * @return {{ [String]: Model|Collection }}
   */
  $relations () {
    return {
      servers: Servers
    }
  }

  /**
   * Check if a feature is enabled
   *
   * @param {String} feature
   *
   * @return {Boolean}
   */
  isFeatureEnabled (feature) {
    this.throwErrorIfFeatureDoesNotExist(feature)

    return this.get('features')[feature] === true
  }

  /**
   * Check if a feature is enabled
   *
   * @param {String} feature
   *
   * @return {Boolean}
   */
  getFeature (feature) {
    this.throwErrorIfFeatureDoesNotExist(feature)

    return this.get('features')[feature]
  }

  /**
   * Check if environment of specific type
   *
   * @param {String} type
   *
   * @returns {Boolean}
   */
  typeOf (type) {
    return this.get(type).toLowerCase() === type.toLowerCase()
  }

  /**
   * Throw error if the feature does not exist in the features list
   *
   * @param {String} feature
   * @returns {Throwable|void}
   */
  throwErrorIfFeatureDoesNotExist (feature) {
    if (!(this.get('features').hasOwnProperty(feature))) {
      throw FEATURE_NOT_EXIST.bind({ feature })()
    }
  }
}

export const FEATURE_NOT_EXIST = function () {
  return new Error(`'${this.feature}' does not exist in features list!`)
}
